import { render, staticRenderFns } from "./SPRMultiSelect.vue?vue&type=template&id=4bf95f18"
import script from "./SPRMultiSelect.vue?vue&type=script&lang=js"
export * from "./SPRMultiSelect.vue?vue&type=script&lang=js"
import style0 from "./SPRMultiSelect.vue?vue&type=style&index=0&id=4bf95f18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports